import { white } from '@edulastic/colors'
import { get } from 'lodash'
import { EduElse, EduIf, EduThen, notification } from '@edulastic/common'
import IconMagicWand from '@edulastic/icons/src/IconMagicWand'
import { roleuser } from '@edulastic/constants'
import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from 'react'
import connect from 'react-redux/es/connect/connect'
import { compose } from 'redux'
import i18 from '@edulastic/localization'
import { Tooltip } from 'antd'
import { withRouter } from 'react-router-dom'
import { segmentApi } from '@edulastic/api'
import SelectGroupModal from '../../../TestPage/components/AddItems/SelectGroupModal'
import { getStandardsListSelector } from '../../../src/selectors/dictionaries'
import AiTestBanner from './CreateAiTestBanner'
import { CreateAITest } from './CreateAITest'
import { aiTestActions } from './ducks'
import { useSaveForm } from './hooks/useSaveForm'
import {
  AiEduButton,
  FullHeightAiEduButton,
  StyledAiTestLoadingModal,
  StyledHoverSpan,
} from './styled'
import { setQuestionDataAction } from '../../../QuestionEditor/ducks'
import { getCurrentQuestionSelector } from '../../../sharedDucks/questions'
import {
  clearCreatedItemsAction,
  getTestEntitySelector,
  isSectionAdaptiveTestSelector,
  setDefaultTestDataAction,
} from '../../../TestPage/ducks'
import {
  allowInstantLessonPackageSelector,
  getUserRole,
  isGcpsDistrictSelector,
  isPremiumUserSelector,
  isVideoQuizAndAIEnabledSelector,
  isGenAIEnabledSelector,
} from '../../../src/selectors/user'
import AddOnTag from '../common/AddOnTag'
import { CREATE_AI_TEST_DISPLAY_SCREENS } from './constants'
import CreateAiTestBannerSmall from './CreateAiTestBannerSmall'
import VerticalTextSlider from '../../../../common/components/VerticalTextSlider'
import { questionGenerationLoadingTexts } from '../../../AssessmentPage/VideoQuiz/constants'
import { AI_CREATION_OPTIONS, STATUS } from './ducks/constants'
import { navigationState } from '../../../src/constants/navigation'
import {
  aiBundleTrialExpired,
  getIsSubscriptionExpired,
  getProducts,
} from '../../../Subscription/ducks'
import SignupAndTrialModals from '../SignupAndTrialModals'
import appConfig from '../../../../../app-config'
import PickAITestCreationOptionsModal from './PickAITestCreationOptionsModal'
import ILPDrawer from './ILPDrawer'
import UnVerifiedUserWarningModal from '../../../../common/components/UnVerifiedUserWarningModal'
import {
  getEmailVerified,
  getVerificationTS,
  isDefaultDASelector,
  isSignupUsingUNAndPassSelector,
} from '../../../../student/Login/ducks'

const {
  NEW_TEST_SCREEN,
  ADD_ITEMS_SCREEN,
  CREATE_TEST_SCREEN,
  CREATE_ITEMS_SCREEN,
  SEARCH_NO_DATA_SCREEN,
  ADD_ITEMS_NO_DATA_SCREEN,
} = CREATE_AI_TEST_DISPLAY_SCREENS

const EduAIQuiz = ({
  test,
  addItems,
  aiTestStatus,
  getAiGeneratedTestItems,
  resetTestDetails,
  standardsList,
  setDefaultTest,
  clearCreatedItem,
  history,
  isVideoQuizAndAIEnabled,
  hasAiBundleTrialExpired,
  hasTeacherPremiumSubscriptionExpired,
  products,
  currentGroupIndexValueFromStore,
  showSelectGroupIndexModal,
  isGcpsDistrict,
  displayScreen = NEW_TEST_SCREEN,
  isSectionAdaptiveTest,
  question = {},
  setQuestionData,
  userRole,
  childrenStyle = {},
  isPremiumUser,
  disableGenerate = false,
  myForwardedRef,
  isILPFlow = false,
  isILPButton = false,
  showILPProductSelectionScreen = false,
  defaultGrades = [],
  defaultSubjects = [],
  allowInstantLessonPackage = false,
  emailVerified,
  verificationTS,
  isDefaultDA,
  isSignupUsingUNAndPass,
  isGenAIEnabled = false,
  children,
}) => {
  const {
    selectSectionVisible,
    isVisible,
    onCreateItems: createItems,
    onCancel,
    closeDrawer,
    handleFieldDataChange,
    handleAiFormSubmit,
    aiFormContent,
    handleChangeStandard,
    updateAlignment,
    selectedGroupIndex,
    handleSelectGroupResponse,
    attachmentType,
    setAttachmentType,
    handleAttachmentChange,
    attachmentMessageData,
    setAttachmentMessageData,
    isGenerateDisabled,
    setIsGenerateDisabled,
  } = useSaveForm({
    hasSections: test?.hasSections,
    isAiGeneratedTest: test?.aiGenerated,
    getAiGeneratedTestItems,
    addItemsView: false,
    resetTestDetails,
    standardsList,
    addItems,
    setDefaultTest,
    clearCreatedItem,
    currentGroupIndexValueFromStore,
    showSelectGroupIndexModal,
    savePreselected:
      displayScreen === CREATE_ITEMS_SCREEN ||
      displayScreen === CREATE_TEST_SCREEN,
    isSectionAdaptiveTest,
    adaptiveDeliveryData: test?.adaptiveDelivery || {},
    itemGroups: test?.itemGroups || [],
  })

  const [showFreeTrialModalsFlow, setShowFreeTrialModalsFlow] = useState(false)
  const [
    showTestCreationOptionsModal,
    setShowTestCreationOptionsModal,
  ] = useState(false)
  const [isILPVisible, setIsILPVisible] = useState(false)
  const [
    showUnVerifiedUserWarningModal,
    setShowUnVerifiedUserWarningModal,
  ] = useState(false)

  // Memoize isTestGenerationScreen to avoid duplicate declarations
  const isTestGenerationScreen = useMemo(
    () =>
      displayScreen === NEW_TEST_SCREEN || displayScreen === CREATE_TEST_SCREEN,
    [displayScreen]
  )

  useImperativeHandle(myForwardedRef, () => ({
    createItems: () => {
      createItems(true)
    },
  }))

  const onAITestCreationOptionSelect = (option) => {
    setShowTestCreationOptionsModal(false)
    if (option === AI_CREATION_OPTIONS.PEAR_ASSESSMENT_AI) {
      createItems()
    } else if (option === AI_CREATION_OPTIONS.INSTANT_LESSON_PACKAGE) {
      setIsILPVisible(true)
    }
  }

  const handleILPFlow = ({ _isILPButton = false }) => {
    if (
      !emailVerified &&
      (verificationTS || isSignupUsingUNAndPass) &&
      !isDefaultDA
    ) {
      setShowUnVerifiedUserWarningModal(true)
      return
    }

    // For test generation screens, only bypass options modal if feature flag is enabled
    const shouldBypassOptionsModal = isTestGenerationScreen && isGenAIEnabled

    if (_isILPButton || !isVideoQuizAndAIEnabled || shouldBypassOptionsModal) {
      setIsILPVisible(true)
      return
    }
    setShowTestCreationOptionsModal(true)
  }

  /**
   * Some of the existing create items/test with AI buttons are the entry points to open ILP drawer.
   * Such entry points to ILP drawer have prop isILPFlow set to true.
   * The dedicated ILP button on dashboard is another entry point to open ILP drawer.
   * isILPButton prop is set to true for this button to open the drawer directly
   * without showing the test creation options modal.
   */
  const onCreateTestClick = ({
    showSelectGroup = true,
    source = 'Test Library',
    isILPFlow: _isILPFlow = false,
    isILPButton: _isILPButton = false,
  } = {}) => {
    if (displayScreen === CREATE_ITEMS_SCREEN) {
      source = 'Item Bank'
    } else if (displayScreen === ADD_ITEMS_SCREEN) {
      source = 'Add Items'
    }
    segmentApi.genericEventTrack('AIQuizCreateTestClick', {
      source,
    })

    // Only always use ILP for test generation screens if feature flag is enabled
    const shouldUseILPForTestGeneration =
      isTestGenerationScreen && isGenAIEnabled

    if (
      shouldUseILPForTestGeneration ||
      (allowInstantLessonPackage && _isILPFlow)
    ) {
      handleILPFlow({ _isILPButton })
      return
    }

    if (!isVideoQuizAndAIEnabled) {
      if (
        hasTeacherPremiumSubscriptionExpired ||
        hasAiBundleTrialExpired ||
        userRole !== roleuser.TEACHER
      ) {
        history.push({
          pathname: '/author/subscription',
          state: { view: navigationState.SUBSCRIPTION.view.ADDON },
        })
      } else {
        setShowFreeTrialModalsFlow(true)
      }
    } else {
      createItems(showSelectGroup)
    }
  }

  useEffect(() => {
    if (isVisible) {
      // resetting skip standard checkbox
      if (question?.shouldSkipEmptyStandardWarning) {
        setQuestionData({
          ...question,
          shouldSkipEmptyStandardWarning: false,
        })
      }
    }
  }, [isVisible])

  useEffect(() => {
    if (aiTestStatus === STATUS.SUCCESS) {
      closeDrawer()
    }
  }, [aiTestStatus])

  const EduAiAddItemsButton = (
    <AiEduButton
      aiStyle
      disabled={!isVideoQuizAndAIEnabled || isSectionAdaptiveTest}
      onClick={onCreateTestClick}
      data-cy="createItemUsingAi"
    >
      <IconMagicWand fill={`${white}`} />
      Create Items Using AI
    </AiEduButton>
  )

  const EduAiAddItems = (
    <EduIf condition={isVideoQuizAndAIEnabled || isSectionAdaptiveTest}>
      <EduThen>
        <Tooltip
          title={
            <>
              <p>
                {isSectionAdaptiveTest
                  ? i18.t('author:notSupportedForSectionsAdaptiveTest.info')
                  : i18.t('author:rubric.infoText')}
              </p>
            </>
          }
        >
          <div>{EduAiAddItemsButton}</div>
        </Tooltip>
      </EduThen>
      <EduElse>
        <AddOnTag
          component={EduAiAddItemsButton}
          message={i18.t('author:aiSuite.addOnText')}
        />
      </EduElse>
    </EduIf>
  )

  const EduCreateAddonTag = (
    <EduIf condition={!allowInstantLessonPackage && !isVideoQuizAndAIEnabled}>
      <AddOnTag isWithAiButton message={i18.t('author:aiSuite.addOnText')} />
    </EduIf>
  )

  const EduCreateItemsWithAiButton = (
    <>
      <FullHeightAiEduButton
        aiStyle
        onClick={() => onCreateTestClick({ isILPFlow: true })}
        data-cy="createItemsWithAi"
      >
        <IconMagicWand fill={`${white}`} />
        Create Items with AI
      </FullHeightAiEduButton>
      {EduCreateAddonTag}
    </>
  )

  const getComponentToDisplay = (screen) => {
    // Only pass isILPFlow: true for test generation screens if feature flag is enabled
    // Use memoized isTestGenerationScreen for current displayScreen, or compute for passed screen
    const screenIsTestGeneration =
      screen === NEW_TEST_SCREEN || screen === CREATE_TEST_SCREEN
    const shouldUseILPFlow = screenIsTestGeneration && isGenAIEnabled

    switch (screen) {
      case ADD_ITEMS_SCREEN:
        return EduAiAddItems
      case NEW_TEST_SCREEN:
        return (
          <AiTestBanner
            onCreateItems={() =>
              onCreateTestClick({ isILPFlow: shouldUseILPFlow })
            }
          />
        )
      case CREATE_TEST_SCREEN:
        return (
          <FullHeightAiEduButton
            aiStyle
            onClick={() => onCreateTestClick({ isILPFlow: shouldUseILPFlow })}
            data-cy="createTestWithAi"
          >
            <IconMagicWand fill={`${white}`} />
            Create Test with AI
            {EduCreateAddonTag}
          </FullHeightAiEduButton>
        )
      case CREATE_ITEMS_SCREEN:
        return EduCreateItemsWithAiButton
      case SEARCH_NO_DATA_SCREEN:
        return (
          <CreateAiTestBannerSmall
            onCreateItems={() =>
              onCreateTestClick({ isILPFlow: shouldUseILPFlow })
            }
          />
        )
      case ADD_ITEMS_NO_DATA_SCREEN:
        return (
          <CreateAiTestBannerSmall
            onCreateItems={() =>
              onCreateTestClick({ isILPFlow: shouldUseILPFlow })
            }
            bannerText="Need more content? Create using AI-powered items"
          />
        )
      default:
        return <></>
    }
  }

  const vqProductId = products?.find(
    ({ linkedProductId }) =>
      linkedProductId === appConfig.videoQuizDefaultCollection.collectionId
  )

  const trialCancelHandle = ({ action }) => {
    setShowFreeTrialModalsFlow(false)
    segmentApi.genericEventTrack('CreateAITestFreeTrial:Cancel', {
      source: displayScreen,
      action,
    })
  }
  const trialSuccessHandle = () => {
    notification({
      type: 'success',
      msg: isPremiumUser
        ? 'Video Quiz and AI suite activated.'
        : 'Trial for Teacher Premium with AI Add-on activated.',
    })

    setShowFreeTrialModalsFlow(false)
    createItems()

    segmentApi.genericEventTrack('CreateAITestFreeTrial:Success', {
      source: displayScreen,
    })
  }
  return (
    <EduIf condition={!isGcpsDistrict}>
      {showFreeTrialModalsFlow && (
        <SignupAndTrialModals
          showAIBanner
          trialProducts={[vqProductId]}
          onCancel={trialCancelHandle}
          onTrialSubsConfirmation={trialSuccessHandle}
        />
      )}
      {children ? (
        <StyledHoverSpan
          style={childrenStyle}
          onClick={() =>
            onCreateTestClick({
              showSelectGroup: true,
              source: displayScreen,
              isILPFlow,
              isILPButton,
            })
          }
        >
          {children}
        </StyledHoverSpan>
      ) : (
        getComponentToDisplay(displayScreen)
      )}

      {showUnVerifiedUserWarningModal && (
        <UnVerifiedUserWarningModal
          visible={showUnVerifiedUserWarningModal}
          onCloseModal={() => setShowUnVerifiedUserWarningModal(false)}
          closeButtonText="GO BACK"
        />
      )}

      {showTestCreationOptionsModal && (
        <PickAITestCreationOptionsModal
          visible={showTestCreationOptionsModal}
          onOptionSelect={onAITestCreationOptionSelect}
          onCloseModal={() => setShowTestCreationOptionsModal(false)}
        />
      )}
      <EduIf condition={addItems}>
        <SelectGroupModal
          visible={selectSectionVisible}
          test={test}
          handleResponse={handleSelectGroupResponse}
          isSectionAdaptiveTest={isSectionAdaptiveTest}
        />
      </EduIf>
      <StyledAiTestLoadingModal
        visible={aiTestStatus === STATUS.INPROGRESS}
        title={null}
        footer={null}
        width="50%"
        centered
        padding="30px 60px"
        bodyPadding="0px"
        borderRadius="10px"
        closeTopAlign="14px"
        closeRightAlign="10px"
        closeIconColor="black"
        zIndex={1006}
        maskClosable={false}
      >
        <VerticalTextSlider
          texts={questionGenerationLoadingTexts}
          textChangeInterval={5}
        />
      </StyledAiTestLoadingModal>
      <CreateAITest
        onCancel={onCancel}
        isVisible={isVisible}
        handleFieldDataChange={handleFieldDataChange}
        handleAiFormSubmit={() => handleAiFormSubmit(selectedGroupIndex)}
        aiTestStatus={aiTestStatus}
        handleChangeStandard={handleChangeStandard}
        aiFormContent={aiFormContent}
        updateAlignment={updateAlignment}
        addItems={addItems}
        onChangeAttachmentType={setAttachmentType}
        attachmentType={attachmentType}
        handleAttachmentChange={handleAttachmentChange}
        attachmentMessageData={attachmentMessageData}
        setAttachmentMessageData={setAttachmentMessageData}
        isGenerateDisabled={isGenerateDisabled || disableGenerate}
        setIsGenerateDisabled={setIsGenerateDisabled}
      />
      {isILPVisible && (
        <ILPDrawer
          visible={isILPVisible}
          setIsILPVisible={setIsILPVisible}
          showILPProductSelectionScreen={
            displayScreen === NEW_TEST_SCREEN ||
            displayScreen === CREATE_TEST_SCREEN
              ? false
              : showILPProductSelectionScreen
          }
          defaultGrades={defaultGrades}
          defaultSubjects={defaultSubjects}
        />
      )}
    </EduIf>
  )
}

const enhance = compose(
  withRouter,
  connect(
    (state) => ({
      isPremiumUser: isPremiumUserSelector(state),
      aiTestStatus: state?.aiTestDetails?.status,
      standardsList: getStandardsListSelector(state),
      isVideoQuizAndAIEnabled: isVideoQuizAndAIEnabledSelector(state),
      hasAiBundleTrialExpired: aiBundleTrialExpired(state),
      hasTeacherPremiumSubscriptionExpired: getIsSubscriptionExpired(state),
      products: getProducts(state),
      isGcpsDistrict: isGcpsDistrictSelector(state, true),
      test: getTestEntitySelector(state),
      isSectionAdaptiveTest: isSectionAdaptiveTestSelector(state),
      question: getCurrentQuestionSelector(state),
      userRole: getUserRole(state),
      defaultGrades: get(state, 'user.user.orgData.defaultGrades', []),
      defaultSubjects: get(state, 'user.user.orgData.defaultSubjects', []),
      allowInstantLessonPackage: allowInstantLessonPackageSelector(state),
      emailVerified: getEmailVerified(state),
      verificationTS: getVerificationTS(state),
      isDefaultDA: isDefaultDASelector(state),
      isSignupUsingUNAndPass: isSignupUsingUNAndPassSelector(state),
      isGenAIEnabled: isGenAIEnabledSelector(state),
    }),
    {
      getAiGeneratedTestItems: aiTestActions.getAiGeneratedTestItems,
      resetTestDetails: aiTestActions.resetTestDetails,
      setDefaultTest: setDefaultTestDataAction,
      clearCreatedItem: clearCreatedItemsAction,
      setQuestionData: setQuestionDataAction,
    }
  )
)
const EnhancedComponent = enhance(EduAIQuiz)

export default forwardRef((props, ref) => (
  <EnhancedComponent {...props} myForwardedRef={ref} />
))
